import Taskbar from '../components/Taskbar';
import AnimatedSection from '../components/AnimatedSection';
import TwoColumnLayout from "../components/TwoColumnLayout";
import AppSidebar from "../components/AppSidebar";
 

const ITestify = () => {
  const images = [
    "/images/Itestify/Itestify1.jpg",
    "/images/Itestify/Itestify2.jpg",
    "/images/Itestify/Itestify3.jpg"
  ];
  const captions = ["I Testify", "I Testify", "We Testify"];

  return (
    <>
     <Taskbar />
     <TwoColumnLayout sidebar={<AppSidebar />}>
      <div className="max-[942px]:pt-8 min-[942px]:mt-[51px] text-text bg-bg text-text transition-colors duration-500">
       
          <AnimatedSection images={images} captions={captions} title="I Testify" />
          <h2 className='text-3xl font-bold text-center mt-40 mb-10'>Coming Soon...</h2>
      </div>
      </TwoColumnLayout>
    </>
  );
};

export default ITestify;
